import { render, staticRenderFns } from "./NewOrderList.vue?vue&type=template&id=604cf2a2&"
import script from "./NewOrderList.vue?vue&type=script&lang=js&"
export * from "./NewOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports